<template>
	<div class="BasePastSalesTable">
		<simplebar class="simplebar">
			<table>
				<thead>
					<tr>
						<th v-for="(headings, i1) in processedCsvData.headings" :key="i1">
							{{ headings.value }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, i2) in processedCsvData.rows" :key="i2">
						<td
							:class="{ error: row.Edit.isError }"
							@click="handleButtonClick(row, i2, 'edit')"
						>
							<span
								style="display: block;cursor:pointer; width: 100%; height: 100%;padding: 20px 0"
							>
								<i :class="[row.Edit.value]" class="text-green" />
							</span>
						</td>
						<td
							:class="{ error: row.Delete.isError }"
							@click="handleButtonClick(row, i2, 'delete')"
						>
							<span
								style="display: block;cursor:pointer; width: 100%; height: 100%;padding: 20px 0"
							>
								<i :class="[row.Delete.value]" class="text-red" />
							</span>
						</td>
						<td :class="{ error: row['Calendar Date'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Calendar Date'].isError"
									class="item"
									effect="dark"
									:content="row['Calendar Date'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{
											row["Calendar Date"].value
												? row["Calendar Date"].value
												: "-"
										}}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Time'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Time'].isError"
									class="item"
									effect="dark"
									:content="row['Time'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{ row["Time"].value ? row["Time"].value : "-" }}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Bill No'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Bill No'].isError"
									class="item"
									effect="dark"
									:content="row['Bill No'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{ row["Bill No"].value ? row["Bill No"].value : "-" }}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Order Type'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Order Type'].isError"
									class="item"
									effect="dark"
									:content="row['Order Type'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{
											row["Order Type"].value ? row["Order Type"].value : "-"
										}}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Item Name'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Item Name'].isError"
									class="item"
									effect="dark"
									:content="row['Item Name'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{ row["Item Name"].value ? row["Item Name"].value : "-" }}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Item Code'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Item Code'].isError"
									class="item"
									effect="dark"
									:content="row['Item Code'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{ row["Item Code"].value ? row["Item Code"].value : "-" }}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Total Quantity'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Total Quantity'].isError"
									class="item"
									effect="dark"
									:content="row['Total Quantity'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{
											row["Total Quantity"].value
												? row["Total Quantity"].value
												: "-"
										}}
									</span>
								</el-tooltip>
							</span>
						</td>
						<td :class="{ error: row['Bill Amount'].isError }">
							<span>
								<el-tooltip
									:disabled="!row['Bill Amount'].isError"
									class="item"
									effect="dark"
									:content="row['Bill Amount'].details.join(',')"
									placement="bottom"
								>
									<span style="display: block; width: 100%;height: 100%">
										{{
											row["Bill Amount"].value ? row["Bill Amount"].value : "-"
										}}
									</span>
								</el-tooltip>
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<div class="upload-button">
			<BaseButton
				buttonclass="py-2 px-4 text-sm bg-amp w-4 text-white w-8"
				@click="onUpload"
			>
				Upload
			</BaseButton>
		</div>
		<div class="editRow">
			<el-dialog :visible.sync="dialogVisible" width="40%" top="0">
				<BaseAddEditPS :row-data="rowData" @onSave="savePastSales" />
			</el-dialog>
		</div>
	</div>
</template>
<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import BaseAddEditPS from "../baseAddEditPS/BaseAddEditPS.vue";
import { CommonMixin } from "../../../mixins/common.mixin";
import Headings from "../../utils/csvHeadings.utils";
import Papa from "papaparse";

export default {
	name: "BasePastSalesTable",
	components: {
		simplebar,
		BaseAddEditPS
	},
	mixins: [CommonMixin],
	props: {
		processedCsvData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			dialogVisible: false,
			index: null,
			rowData: {},
			file: null
		};
	},
	computed: {},
	methods: {
		onUpload() {
			if (
				this.processedCsvData.rows.every(row =>
					Object.keys(row).every(key => row[key].isError === false)
				)
			) {
				const csvJson = this.createCsvFile(this.processedCsvData);
				var csv = Papa.unparse(csvJson);
				// console.log("csv", csv);
				var csvData = new Blob([csv]);

				this.$emit("onUpload", csvData);
			} else {
				this.$notify.error({
					title: "Error",
					message: "There are still some erros",
					type: "error"
				});
			}
		},
		createCsvFile(processedCsvData) {
			return processedCsvData.rows.reduce((acc, row) => {
				var obj = {};
				Headings.pastSales.forEach(heading => {
					obj[heading] = row.hasOwnProperty(heading)
						? row[heading].value
						: null;
				});
				acc.push(obj);
				return acc;
			}, []);
		},
		savePastSales(rowData) {
			this.dialogVisible = false;
			this.processedCsvData.rows[this.index] = rowData;
			// console.log("rowData in saveArticleMaster", rowData);
			// this.reTransformRowData(rowData);
		},
		handleButtonClick(row, index, action) {
			console.log("row", row, "index", index);
			this.index = index;

			if (action === "delete") {
				this.handleDeleteRow(index);
			}

			if (action === "edit") {
				const editedRow = this.handleEditRow(row);
			}
		},

		handleEditRow(row, index) {
			this.rowData = this.cloneObject(row);
			// this.rowData = this.transformRowData(row);

			// if (cellData.file === "pastSales") {
			// 	this.fileType = "pastSales";
			// }

			// if (cellData.file === "pastSales") {
			// 	this.fileType = "pastSales";
			// }

			this.dialogVisible = true;
		},

		handleDeleteRow(index) {
			this.$confirm(
				"This will permanently delete the Item Master. Continue?",
				"Warning",
				{
					confirmButtonText: "OK",
					cancelButtonText: "Cancel",
					type: "warning"
				}
			)
				.then(() => {
					this.processedCsvData.rows.splice(index, 1);
					this.$message({
						type: "success",
						message: "Delete completed"
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "Delete canceled"
					});
				});
		}
		// transformRowData(row) {
		// 	return row.reduce((acc, obj) => {
		// 		acc[obj["columnName"]] = obj;
		// 		return acc;
		// 	}, {});
		// },
		// reTransformRowData(row) {
		// 	console.log("row in reTransform", row);
		// 	return Object.keys(row).reduce((acc, key) => {
		// 		console.log(acc, key);
		// 		acc.push(row[key]);
		// 		return acc;
		// 	}, []);
		// }
	}
};
</script>

<style lang="scss" scoped>
@import "./BasePastSalesTable.scss";
</style>
<style lang="scss">
// .box {
// 	width: 200px;
// 	font-size: 20px;

.top {
	text-align: center;
}

.left {
	float: left;
	width: 110px;
}

// .right {
// 	float: right;
// 	width: 110px;
// }

.bottom {
	clear: both;
	text-align: center;
}

.item {
	margin: 4px;
}

.left .el-tooltip__popper,
.right .el-tooltip__popper {
	padding: 8px 10px;
}
.el-tooltip__popper {
	max-width: 300px;
	font-size: 18px;
}
.el-tooltip__popper.is-dark {
	background: rgba(0, 0, 0, 0.5);
}

.BasePastSalesTable .el-button {
	min-width: 110px;
}
// }
</style>
